import React, { useState } from "react";
import { Link } from "react-router-dom";
import AcademicSchedule from "./academicschedule";
import AcademicAttendance from "./academicattendance";
import AcademicGrade from "./academicgrade";
import AcademicAssessment from "./academicassessment";
import AcademicCcSkills from "./adminccskills";

const AcademicsTab = () => {

    const [activeTab, setActiveTab] = useState("Schedule");

    const tabData = [
        {
            icon: <i className="fas fa-calendar" />,
            name: "Schedule",
            content: <AcademicSchedule />
        },
        {
            icon: <i className="fas fa-user-check" />,
            name: "Attendance",
            content: <AcademicAttendance />
        },
        {
            icon: <i className="fas fa-user-graduate" />,
            name: "Grade",
            content: <AcademicGrade />
        },
        {
            icon: <i className="fas fa-clipboard-check" />,
            name: "Assessment",
            content: <AcademicAssessment />
        },
        {
            icon: <i className="fas fa-walking" />,
            name: "CC Skills",
            content: <AcademicCcSkills />
        }
    ]
    return (
        <>
            <div className="content container">
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row d-flex align-items-center">
                                <h3 className="text-center mb-40">Academic</h3>
                            </div>
                            <div className="row d-flex align-items-center">
                                <div className="col-xl-12 col-lg-12 col-sm-12 col-md-12">
                                    <div className="coach-court-list">
                                        <ul className="nav">
                                            {tabData.map((tab, i) => (
                                                <li key={i}>
                                                    <Link to="#"
                                                        className={tab.name === activeTab ? 'active' : ''}
                                                        onClick={() => setActiveTab(tab.name)}>
                                                        {tab.icon}  {tab.name}
                                                    </Link>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                                <div className="tab-content">
                                    {tabData
                                        .filter(tab => tab.name === activeTab)
                                        .map((tab, i) => (
                                            <div key={i}>{tab.content}</div>
                                        ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AcademicsTab;